export default {
  done: 'green',
  warning: 'orange',
  error: 'red',
  pending: 'grey',
};
